export const ACESSO_ADMINISTRATIVO = 'Administrativo', ACESSO_PUBLICO = 'Publico';